import templateUrl from './404NotFound.html'

/**
 * Route 404 Not Found.
 *
 * @namespace routes.404NotFound
 * @type {TmrRoute}
 */
export const route = {
  name: 'error404',
  label: '404.TITLE',
  component: 'tmrNotFound',
  accessControl: [],
  accessAnonymous: true,
}

/**
 * Component for the route 404 Not Found.
 *
 * @type {ngComponent}
 */
export const tmrNotFound = {
  ngType: 'component',
  templateUrl,
}

/**
 * Route 404 Not Found configurations.
 *
 * Tells the system to redirect request that don't match any state to route 404 Not Found.
 *
 * @type {ngConfig}
 */
let tmr404NotFoundConfig = /*@ngInject*/ $urlServiceProvider =>
  $urlServiceProvider.rules.otherwise({ state: 'app.error404' })

export { tmr404NotFoundConfig as config }
